<template>
    <div class="form-group focused datePicker" :class="{'has-error':errors[title]!=undefined,'focused':modelValue!='' && modelValue!=null?true:false,'buttons':buttons==true}">
        <Datepicker locale="tr" ref="datepicker" autoApply :format-locale="tr"  format="dd.MM.yyyy" :enableTimePicker="false" cancelText="İptal" selectText="Tamam" 
        class="form-control" v-bind="$attrs" :id="uid"  :class="{'parsley-error':errors[title]!=undefined}"
        v-model="model"
        ></Datepicker>
        <Field v-model="model"  :name="title" :rules="rules" />
		<label class="control-label" :for="uid">{{title}} </label>
        <ErrorMessage as="span" class="form-control-feedback small" :name="title" />
    </div>
</template>
<script>
  import Datepicker from '@vuepic/vue-datepicker';
  import '@vuepic/vue-datepicker/dist/main.css'
  import { tr } from 'date-fns/locale';
    export default {
        name:"datePicker",
        components: { Datepicker },
        props:["errors","title","modelValue","rules","buttons"],
        data(){
            return{
                uid:this.$uniqueid(),
                tr:tr,
                model:this.modelValue
            }
        }
    }
</script>
<style scope>
    .myDatePicker{
        position: relative;
    }
    .label{
        right: 0 !important;
        left:auto !important;
        background: #e9ecef !important;
        color:#747d86 !important;
        top:0 !important;
        line-height: 38px !important;
        transform: translate(0) !important;
        border:1px solid #d9d9d9;
        width:60px;
        text-align: center;
        font-size: 16px !important;
        border-radius: 0;
        cursor: pointer;
        height: auto !important;
        max-height: 100%;
    }
    .label input{
        width:0;
        height:0;
        border:none;
        opacity: 0;
    }
    .label i{
        display: inline-block;
        width:100%;
    }
    .myDatePicker svg{
        height:30px !important;
        width:30px !important;
    }
    /* .disabled{
        position: absolute;
        left:0;
        top:0;
        width:100%;
        height:100%;
        background: red;
        display: none;
    } */
</style>

